/**
 * 新闻状态模块
 * 管理新闻列表、详情、发布等
 */

import newsApi from '@/api/news'

const state = {
  publicNewsList: [],       // 公开新闻列表
  myNewsList: [],           // 我的新闻列表
  newsDetail: null          // 新闻详情
}

const mutations = {
  /**
   * 设置公开新闻列表
   * @param state
   * @param list
   */
  setPublicNewsList(state, list) {
    state.publicNewsList = list
  },
  
  /**
   * 设置我的新闻列表
   * @param state
   * @param list
   */
  setMyNewsList(state, list) {
    state.myNewsList = list
  },
  
  /**
   * 设置新闻详情
   * @param state
   * @param detail
   */
  setNewsDetail(state, detail) {
    state.newsDetail = detail
  }
}

const actions = {
  /**
   * 获取公开新闻列表
   * @param commit
   * @param params
   */
  async fetchPublicNews({ commit }, params) {
    const res = await newsApi.getPublicNews(params)
    if (res && res.code === 2000) {
      commit('setPublicNewsList', res.data.list || [])
    }
    return res
  },
  
  /**
   * 获取我的新闻列表
   * @param commit
   * @param params
   */
  async fetchMyNews({ commit }, params) {
    const res = await newsApi.getMyNews(params)
    if (res && res.code === 2000) {
      commit('setMyNewsList', res.data.list || [])
    }
    return res
  },
  
  /**
   * 获取新闻详情
   * @param commit
   * @param id
   */
  async fetchNewsDetail({ commit }, id) {
    const res = await newsApi.getNewsDetail(id)
    if (res && res.code === 2000) {
      commit('setNewsDetail', res.data)
    }
    return res
  },
  
  /**
   * 发布新闻
   * @param dispatch
   * @param data
   */
  async publishNews({ dispatch }, data) {
    const res = await newsApi.publishNews(data)
    if (res && res.code === 2000) {
      // 重新获取我的新闻列表
      await dispatch('fetchMyNews', {})
    }
    return res
  },
  
  /**
   * 更新新闻
   * @param dispatch
   * @param payload
   */
  async updateNews({ dispatch }, { id, data }) {
    const res = await newsApi.updateNews(id, data)
    if (res && res.code === 2000) {
      // 重新获取我的新闻列表
      await dispatch('fetchMyNews', {})
    }
    return res
  }
}

const getters = {
  publicNewsList: state => state.publicNewsList,
  myNewsList: state => state.myNewsList,
  newsDetail: state => state.newsDetail,
  
  // 草稿新闻数量
  draftCount: state => {
    return state.myNewsList.filter(news => news.is_draft === 1).length
  },
  
  // 已发布新闻数量
  publishedCount: state => {
    return state.myNewsList.filter(news => news.is_draft === 0 && news.status === 0).length
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
